// extracted by mini-css-extract-plugin
export default {"container":"SummaryTab__container--m7nXR"};